'use strict';

require('prop-types');
var React = require('react');
var withStyles = require('../../node_modules/@material-ui/core/styles/withStyles.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var ObjectHelper = require('../../common/ObjectHelper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  inline: {
    display: 'inline'
  }
};

var PreparerDetails = function PreparerDetails(_ref) {
  var preparer = _ref.preparer,
      number = _ref.number,
      date = _ref.date,
      settings = _ref.settings,
      isPresenting = _ref.isPresenting,
      classes = _ref.classes;
  var show_date = settings.show_date,
      show_technician_name = settings.show_technician_name;
  var showPreparer = ObjectHelper.isPresent(preparer) && show_technician_name && !isPresenting;
  return React__default["default"].createElement(React.Fragment, null, showPreparer && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Typography, {
    className: classes.inline
  }, "Prepared by \xA0"), React__default["default"].createElement(Typography, {
    className: classes.inline,
    variant: "subtitle2"
  }, preparer, " \xA0"), React__default["default"].createElement(Typography, {
    className: classes.inline
  }, "| \xA0")), React__default["default"].createElement(Typography, {
    className: classes.inline
  }, "#", number, " ", show_date ? "| ".concat(date) : ''));
};

var PreparerDetails$1 = withStyles(styles)(PreparerDetails);

module.exports = PreparerDetails$1;
